import {InjectionToken} from '@angular/core';

export const SOFTLINE_FEATURE_REGISTRATION = 'registration';

export interface RegistrationModuleConfig {
  links?: {
    name: string,
    route: string | string[]
  }[];
}

export const REGISTRATION_MODULE_CONFIG = new InjectionToken<RegistrationModuleConfig>('REGISTRATION_MODULE_CONFIG');
